import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=9d994436&scoped=true"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=9d994436&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d994436",
  null
  
)

export default component.exports